<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-25 16:52:42
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:37
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsResources.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="goods-resoureces">
		<span :class="['platform-tag', 'mr-4', 'fz-12', merchantGoods ? 'merchant-active' : '']">{{
			merchantGoods ? '商家' : '团长' | formatEmpty
		}}</span>
		<rd-text width="140" class="rd-text font-h6-regular">
			{{ merchantGoods ? '店铺名称：' : '团长名称：' }}{{ nickNameText | formatEmpty }}
		</rd-text>
		<rd-text :label="'ID'" :showCopy="true" :value="shopOrCommanderId" class="rd-text text-default font-h6-regular">{{
			shopOrCommanderId
		}}</rd-text>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
import { PLATFORM_KS } from '@/utils/dataMap';
export default {
	mixins: [mixin],
	computed: {
		merchantGoods({ row }) {
			return +row.appType === +PLATFORM_KS.value;
		},
		nickNameText({ row, merchantGoods }) {
			return merchantGoods ? row.outerShopName : row.originInstitutionName;
		},
		shopOrCommanderId({ row, merchantGoods }) {
			return merchantGoods ? row.outerShopId : row.originAuthorityId;
		},
	},
	data() {
		return {
			showCopy: false,
		};
	},
	methods: {
		onShow() {
			this.showCopy = true;
		},
		onHide() {
			this.showCopy = false;
		},
	},
};
</script>
<style lang="less" scoped>
.goods-resoureces {
	.platform-tag {
		border-radius: 2px;
		box-sizing: border-box;
		padding: 0 3px 0 3px;
		height: 16px;
		line-height: 15px;
		border: 1px solid @color-b2;
		color: @color-b4;
	}
	.merchant-active {
		border: 1px solid @color-p2 !important;
		color: @color-p4 !important;
	}
	.rd-text {
		color: @color-gy7;
		/deep/ .copy-wrapper {
			opacity: 0;
		}
	}
	.rd-text:hover {
		/deep/ .copy-wrapper {
			opacity: 1;
		}
	}
	/deep/ .copy-wrapper:hover {
		.copy-hover {
			color: @color-primary !important;
		}
	}
}
</style>
